import { render, staticRenderFns } from "./DeliveryTimeStats.vue?vue&type=template&id=00db1865&lang=pug&"
import script from "./DeliveryTimeStats.vue?vue&type=script&lang=ts&"
export * from "./DeliveryTimeStats.vue?vue&type=script&lang=ts&"
import style0 from "./DeliveryTimeStats.vue?vue&type=style&index=0&id=00db1865&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports